import { craftMethodBlocks } from "./content/craft-method";
import { sellContractBlocks } from "./content/sell-contract";
import { sellForbiddenBlocks } from "./content/sell-forbidden";
import { talentBondBlocks } from "./content/talent-bond";
import { talentFormulasBlocks } from "./content/talent-formulas";
import { talentGritBlocks } from "./content/talent-grit";
import { talentInsightBlocks } from "./content/talent-insight";
import { talentInstinctBlocks } from "./content/talent-instinct";
import { threatResponseBlocks } from "./content/threat-response";
import type { WikiPageDef, WikiPageGroup, WikiPageId } from "./types";

/** Group label keys in ko.json */
export const WIKI_GROUP_TITLE_KEYS: Record<WikiPageGroup, string> = {
  combat: "raid.wiki.group.combat",
  talent: "raid.wiki.group.talent",
  contract: "raid.wiki.group.contract",
  craft: "raid.wiki.group.craft",
};

/**
 * Raid Leader wiki page registry (order within group).
 * Titles via ko.json `titleKey`.
 */
export const RAID_WIKI_PAGES: readonly WikiPageDef[] = [
  {
    id: "threat-response",
    titleKey: "raid.wiki.page.threatResponse",
    group: "combat",
    order: 10,
    blocks: threatResponseBlocks,
  },
  {
    id: "talent-instinct",
    titleKey: "raid.wiki.page.instinct",
    group: "talent",
    order: 10,
    blocks: talentInstinctBlocks,
  },
  {
    id: "talent-insight",
    titleKey: "raid.wiki.page.insight",
    group: "talent",
    order: 20,
    blocks: talentInsightBlocks,
  },
  {
    id: "talent-bond",
    titleKey: "raid.wiki.page.bond",
    group: "talent",
    order: 30,
    blocks: talentBondBlocks,
  },
  {
    id: "talent-grit",
    titleKey: "raid.wiki.page.grit",
    group: "talent",
    order: 40,
    blocks: talentGritBlocks,
  },
  {
    id: "talent-formulas",
    titleKey: "raid.wiki.page.talentFormulas",
    group: "talent",
    order: 50,
    blocks: talentFormulasBlocks,
  },
  {
    id: "sell-contract",
    titleKey: "raid.wiki.page.contract",
    group: "contract",
    order: 10,
    blocks: sellContractBlocks,
  },
  {
    id: "sell-forbidden",
    titleKey: "raid.wiki.page.forbidden",
    group: "contract",
    order: 20,
    blocks: sellForbiddenBlocks,
  },
  {
    id: "craft-method",
    titleKey: "raid.wiki.page.craftMethod",
    group: "craft",
    order: 10,
    blocks: craftMethodBlocks,
  },
];

const BY_ID = new Map(RAID_WIKI_PAGES.map((p) => [p.id, p]));

export function wikiPageById(id: WikiPageId): WikiPageDef {
  const p = BY_ID.get(id);
  if (!p) throw new Error(`Unknown raid wiki page: ${id}`);
  return p;
}

export function wikiPagesSorted(): readonly WikiPageDef[] {
  return [...RAID_WIKI_PAGES].sort((a, b) => {
    if (a.group !== b.group) {
      const go = { combat: 0, talent: 1, contract: 2, craft: 3 } as const;
      return go[a.group] - go[b.group];
    }
    return a.order - b.order;
  });
}

export function wikiDefaultPageId(): WikiPageId {
  return wikiPagesSorted()[0]!.id;
}
